module.exports = __webpack_public_path__ + "img/65.f9b77336.jpg";